export default __webpack_public_path__ + "static/media/GCCFlour.3f5a4726.jpg";